<template>
    <v-content>
        <v-dialog v-model="dialogRole" max-width="500px">
            <roleForm v-if="dialogRole"
                      :userInfoDialog="userID"
                      @formResponse="formResponse" />

        </v-dialog>
        <div>

            <v-breadcrumbs :items="breadcrumbItems" large></v-breadcrumbs>
            <v-expansion-panels class="my-2">
                <v-expansion-panel>
                    <v-expansion-panel-header>{{ $t('table.filter') }} </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-container>
                            <v-row style="justify-content:center">
                                <div class="box-border col-3">
                                    <v-select class="pa-2"
                                              v-model="serverParams.fiscalYearID" dense outlined
                                              :items="fiscalYearList"
                                              item-text="id"
                                              item-value="value">
                                        <template v-slot:label>
                                            {{ $t("fiscal_year") }}
                                        </template>
                                    </v-select>
                                </div>

                                <div class="box-border col-3" style="justify-content:center">

                                    <v-radio-group row v-model="serverParams.transferModeID" :mandatory="false">
                                        <v-radio v-for="(status, index) in transferModeType"
                                                 :key="status.value"
                                                 :value="status.value"
                                                 :style="{ color: radioColors[index] }"
                                                 class="custom-radio">
                                            <template v-slot:label>
                                                <span :style="{ color: radioColors[index] }">{{ status.id }}</span>
                                            </template>
                                        </v-radio>
                                    </v-radio-group>
                                </div>

                                <v-col cols="12" md="3">

                                    <v-autocomplete class="pa-2"
                                                    :items="statuslist"
                                                    item-text="id"
                                                    item-value="value"
                                                    :label="$t('status')" dense outlined
                                                    v-model.number="serverParams.statusID">
                                    </v-autocomplete>
                                </v-col>


                            </v-row>

                            <v-row align="center" justify="center">
                                <v-btn color="primary" dark @click="loadItems">
                                    <i class="material-icons">search</i>{{$t('search')}}
                                </v-btn>
                            </v-row>
                        </v-container>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

            <vue-good-table :columns="columns"
                            :rows="rows"
                            mode="remote"
                            styleClass="vgt-table condensed">
                <template slot="table-column" slot-scope="props">
                    <span>
                        {{ $t(props.column.label) }}
                    </span>
                </template>
            </vue-good-table>
            <v-snackbar v-model="snackbar.snackbar"
                        :color="snackbar.color"
                        :timeout="snackbar.timeout"
                        top>
                {{ snackbar.text }}
                <v-btn dark
                       text
                       @click="snackbar.snackbar = false">
                    Close
                </v-btn>
            </v-snackbar>
        </div>
    </v-content>
</template>

<script>
    import axios from "axios";
    import { mapGetters } from "vuex";

    export default {
        name: "UserList",
        components: {
        },
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            breadcrumbItems() {
                return [
                    {
                        text: this.$t('dashboard'),
                        disabled: false,
                        to: `${this.usersData.dashBoard}`,
                        exact: true
                    },
                    {
                        text: this.$t('budget_transfer_report'),
                        disabled: true,
                    },
                ]
            },
            isSuperAdmin() {
                return this.userRole === "SuperAdmin"
            },
        },
        data() {
            return {
                dialogRole: false,
                officeTypeEN: "",
                columns: [
                    {
                        label: 'fiscal_year',
                        field: 'fiscalYearName',
                    },
                    {
                        label: 'company',
                        field: 'companyName',
                    },
                    {
                        label: 'branch',
                        field: 'branchName',
                    },
                    {
                        label: 'depo',
                        field: 'depoName',
                    },
                    {
                        label: 'transferType',
                        field: 'transferModeName',
                    }, {
                        label: "from_subsection",
                        field: "fromSubSectionName"
                    },
                    {
                        label: "to_subsection",
                        field: "toSubSectionName"
                    },
                    {
                        label: 'status',
                        field: 'statusName',
                    }
                ],
                rows: [],
                branchList: [],
                fiscalYearList: [],
                userData: {
                    totalRows: 0,
                    editItemIndex: null,
                    deleteFormData: {}
                },
                listDDLData: {
                    companyList: [],
                    departmentList: [],
                    branchList: [],
                    depoList: []
                },
                serverParams: {
                    branchID: 0,
                    companyID: 0,
                    departmentID: 0,
                    depoID: 0,
                    fiscalYearID: 0,
                    statusID: 0,
                    transferModeID: 0,
                    search: "",
                    columnFilters: {},
                    sort: [
                        {
                            field: "BudgetAddTransferRequestID",
                            type: "desc"
                        }
                    ],
                    page: 1,
                    perPage: 10
                },
                userID: "",
                updateStatus: {
                    isActive: false
                },
                snackbar: {
                    color: '',
                    snackbar: false,
                    text: '',
                    timeout: 6000,
                    isLoading: false,
                    formModal: false,
                    createFormComponent: false,
                    editFormComponent: false,
                    dialogDelete: false,

                    dynamicComponent: {
                        current: 'UserForm'
                    }
                },
                transferModeType: [
                    { id: "सबै", value: 0 },
                    { id: "रकमान्तर", value: 1 },
                    { id: "थप बजेट", value: 2 }
                ],
                statuslist: [
                    { id: "सबै", value: 0 },
                    { id: "अनुरोध", value: 1 },
                    { id: "असफल", value: 2 },
                    { id: "सफल", value: 3 }
                ],
                radioColors: ['#47bf88de', '#FF5733', '#3A89F1', '#9C27B0'],
                totalRecords: 0
            };
        },
        methods: {
            changeStatus(val) {
                let formData = {
                    userID: val.userID,
                    isActive: val.isActive
                }
                axios.post("User/UpdateStatus", formData).then(response => {
                    console.log(response)
                    if (response.data.success) {
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "green";
                        this.snackbar.text = "Status Updated Successfully"
                    }
                })
            },

            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({ page: params.currentPage });
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({ perPage: params.currentPerPage });
                this.loadItems();
            },
            dialogRoleModal(response) {
                console.log(response)
                this.userID = response.userID
                this.dialogRole = true;
            },
            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params[0].type,
                        field: params[0].field,
                    }],
                });
                this.loadItems();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
            addModal() {
                this.snackbar.formModal = true
                this.snackbar.createFormComponent = true
            },
            editItem(item) {
                this.snackbar.formModal = true
                this.snackbar.editFormComponent = true
                this.userData.editItemIndex = item.budgetAddTransferRequestID
            },
            deleteItemRoom(item) {
                this.snackbar.dialogDelete = true;
                this.userData.deleteFormData.url = "User/DeleteUser/" + item.userID;
                this.loadItems();
            },
            onResponseDelete() {
                this.snackbar.dialogDelete = false;
                this.loadItems();
            },
            formResponse(responseObj) {
                if (responseObj.message) {
                    this.snackbar.color = responseObj.color ? responseObj.color : 'red'
                    this.snackbar.text = responseObj.message ? responseObj.message : 'Server Error'
                    this.snackbar.snackbar = true
                    this.dialogRole = false

                    this.loadItems();
                }
                else {
                    this.dialogRole = false

                }

            },
            dialogueClose() {
                this.userData.editItemIndex = null
                this.snackbar.formModal = false
                this.snackbar.createFormComponent = false
                this.snackbar.editFormComponent = false
                this.loadItems()
            },
            async loadItems() {
                this.snackbar.isLoading = true;
                    let param = {
                        transferModeID: this.serverParams.transferModeID,
                        statusID: this.serverParams.statusID,
                        fiscalYearID: parseInt(this.serverParams.fiscalYearID),
                    };
                axios.post('ReportSettings/GetallBudgetTransferInformationlogs', param).then(response => {
                        this.rows = response.data
                        this.snackbar.loading = false;
                    }).catch(res => {
                        console.log(res)
                    })


            },
            async getData() {
                axios.get("ReportSettings/GetReportYearList").then(response => {
                    this.fiscalYearList = response.data
                })
            },
            currentFiscalYear() {
                axios.get("ReportSettings/GetCurrentFiscalYear").then(response => {
                    this.serverParams.fiscalYearID = response.data.value
                })
            },
            
        },
        mounted() {
            this.loadItems()
            this.getData()
            this.getDdlData()

        },
        created() {
            this.currentFiscalYear()
        },

    }
</script>

<style scoped>
</style>
